import { NgClass } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { ConsentService } from '@core/consent';
import { CONSENT_PARAM } from '@core/jss-seo';

@Component({
  selector: 'wl-video-player',
  standalone: true,
  imports: [NgClass, RouterLink, CrntButtonAlt],
  templateUrl: './video-player.component.html',
})
export class VideoPlayerComponent {
  readonly videoId = input.required<string>();
  readonly title = input.required<string>();
  readonly aspectRatio = input<string>('ratio-16x9');

  readonly #sanitizer = inject(DomSanitizer);
  readonly #contentService = inject(ConsentService);

  readonly queryParams = signal({ [CONSENT_PARAM]: true }).asReadonly();

  readonly videoUrl = computed(() =>
    this.#sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${this.videoId()}`
    )
  );

  readonly imageUrl = computed(() =>
    this.#sanitizer.bypassSecurityTrustResourceUrl(
      `https://img.youtube.com/vi/${this.videoId()}/0.jpg`
    )
  );

  public readonly allowsTrackingCookies = computed(() => {
    // re-compute on changes in consentStatus
    this.#contentService.consentStatus();
    return this.#contentService.allowsTrackingCookies();
  });
}
